import { ProjectType } from '@/types';

export const BACKEND_URL = process.env.BACKEND_URL;

export const MOBILE_RESOLUTION = 495;
export const TABLET_RESOLUTION = 1024;

export enum ThemeVariant {
  Dark = 'dark',
  Light = 'light',
}

export const PROJECTS: ProjectType[] = [
  {
    img: '/webp/cloud.webp',
    imgMob: '/webp/cloud-mob.webp',
    link: 'https://cloud.ru/',
    title: 'cases.cloudru',
    stack: 'TypeScript, NextJS, Redux, SCSS, Storybook, React Hook Form',
  },
  {
    img: '/webp/dreamisland.webp',
    imgMob: '/webp/dreamisland-mob.webp',
    link: 'https://dreamisland.ru/',
    title: 'cases.dreamisland',
    stack: 'TypeScript, NextJS, Redux, SCSS, Next Intl, Axios',
  },
  {
    img: '/webp/console-cloud.webp',
    imgMob: '/webp/console-cloud-mob.webp',
    link: 'https://console.cloud.ru/',
    title: 'cases.console',
    stack:
      'TypeScript, React, Redux, Styled Components, React Query, Storybook, Webpack',
  },
  {
    img: '/webp/shopdreamisland.webp',
    imgMob: '/webp/shopdreamisland-mob.webp',
    link: 'https://shop.dreamisland.ru/',
    title: 'cases.shopdreamisland',
    stack:
      'TypeScript, NextJS, Redux, SCSS, Next Intl, Axios, Dadata API, Yandex Maps API',
  },
  {
    img: '/webp/workice.webp',
    imgMob: '/webp/workice-mob.webp',
    link: 'https://workice.ru/',
    title: 'cases.workice',
    stack:
      'TypeScript, NextJS, Redux, SCSS, Next Intl, Axios, NextJS Server, Next Auth, Mongoose',
  },
  {
    img: '/webp/chachingads.webp',
    imgMob: '/webp/chachingads-mob.webp',
    link: 'https://my.chachingads.com/',
    title: 'cases.chachingads',
    stack: 'TypeScript, React, Vite, Redux, SCSS, Tailwind, Axios',
  },
  {
    img: '/webp/myzh.webp',
    imgMob: '/webp/myzh-mob.webp',
    link: 'https://myzh.pro/',
    title: 'cases.myzh',
    stack:
      'TypeScript, NextJS, Redux, SCSS, Next Intl, Axios, Framer Motion, Swiper',
  },
  {
    img: '/webp/avroracity.webp',
    imgMob: '/webp/avroracity-mob.webp',
    link: 'https://avroracity.ru/',
    title: 'cases.avroracity',
    stack:
      'TypeScript, NextJS, SCSS, Emotion, MUI, Framer Motion, Swiper, React Hook Form, Zod, Axios',
  },
  {
    img: '/webp/lazyapp.webp',
    imgMob: '/webp/lazyapp-mob.webp',
    link: 'https://lazyapp.ru/',
    title: 'cases.lazyapp',
    stack:
      'TypeScript, React, Vite, Zustand, SCSS, Ionic, React Query, Socket.IO, Firebase, Axios',
  },
  // {
  //   img: '/webp/enchantx.webp',
  //   imgMob: '/webp/enchantx-mob.webp',
  //   link: 'https://enchantx.tech/',
  //   title: 'cases.enchantx',
  //   stack:
  //     'TypeScript, NextJS, Redux, SCSS, Axios,  NextJS Server, Mongoose, Webpack, React Hook Form',
  // },
  {
    img: '/webp/koreana.webp',
    imgMob: '/webp/koreana-mob.webp',
    link: 'https://koreanalight.ru/',
    title: 'cases.koreana',
    stack: 'TypeScript, NextJS, Redux, SCSS, Next Intl, Axios',
  },
  {
    img: '/webp/dream-beach-club.webp',
    imgMob: '/webp/dream-beach-club-mob.webp',
    link: 'https://dbc.dreamisland.ru/',
    title: 'cases.dbc',
    stack: 'TypeScript, React, Redux, SCSS, React Leaflet',
  },
  {
    img: '/webp/legends.webp',
    imgMob: '/webp/legends-mob.webp',
    link: 'https://8legends.ai/',
    title: 'cases.legends',
    stack: 'TypeScript, NextJS, Redux, Tailwind, Axios, Web3.js, Ethers',
  },
  {
    img: '/webp/tma.webp',
    imgMob: '/webp/tma-mob.webp',
    link: 'https://t.me/InfiniteLegends_bot',
    title: 'cases.tma',
    stack: 'TypeScript, NextJS, Redux, i18next, Axios, Telegram API',
  },
  {
    img: '/webp/zeta.webp',
    imgMob: '/webp/zeta-mob.webp',
    link: 'https://new.zeta.kz/',
    title: 'cases.zeta',
    stack: 'TypeScript, NextJS, Redux, SCSS, Next Intl, Axios, Dadata API',
  },
  {
    img: '/webp/moscow.webp',
    imgMob: '/webp/moscow-mob.webp',
    link: 'https://moscow-hall.ru/',
    title: 'cases.moscow',
    stack: 'TypeScript, NextJS, Redux, SCSS, Axios',
  },
];
